/* ============================================================
   MACRO CALCULATOR - Multi-step wizard JS
   THE BOD - Shopify OS 2.0
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     0. SESSION GATE
     If user lands on /pages/calculator without a session flag,
     redirect to the lead capture page.
     The flag is set when they complete Step 1 (email capture).
  ---------------------------------------------------------- */
  /* Gate removed — macro calculator is now a free ungated tool.
     No session check, no redirect. The calculator renders immediately. */

  /* ----------------------------------------------------------
     1. INIT
  ---------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    const wizard = document.getElementById('tbCalcWizard');
    if (!wizard) return;

    // Gate removed — calculator is free and ungated

    const TOTAL_STEPS = 6; // Steps 1-6 are interactive; step 7 is results
    let currentStep = 1;

    const progressBar = document.getElementById('tbCalcProgressBar');
    const stepIndicator = document.getElementById('tbCalcStepIndicator');
    const captureMessage = document.getElementById('tbCalcCaptureMessage');
    const completionMessage = document.getElementById('tbCalcCompletionMessage');

    function setIntegrationMessage(element, message) {
      if (!element) return;
      element.textContent = message || '';
      element.hidden = !message;
    }

    function setButtonPending(button, isPending, pendingLabel) {
      if (!button) return;

      if (isPending) {
        button.setAttribute('data-default-label', button.textContent);
        button.textContent = pendingLabel;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      } else {
        button.textContent = button.getAttribute('data-default-label') || button.textContent;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }

    /* ----------------------------------------------------------
       2. CARD SELECT LOGIC
    ---------------------------------------------------------- */
    document.querySelectorAll('.tb-card-select').forEach(function (group) {
      group.querySelectorAll('.tb-card-select__option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          // For goal selects, we need to handle multiple groups
          const isGoal = btn.closest('.tb-card-select--goal');
          if (isGoal) {
            // Deselect all goal options across all goal groups
            document.querySelectorAll('.tb-card-select--goal .tb-card-select__option').forEach(function (o) {
              o.classList.remove('tb-card-select__option--selected');
            });
          } else {
            // Deselect siblings in same group
            group.querySelectorAll('.tb-card-select__option').forEach(function (o) {
              o.classList.remove('tb-card-select__option--selected');
            });
          }
          btn.classList.add('tb-card-select__option--selected');

          // Update hidden input
          var value = btn.getAttribute('data-value');
          var hiddenInput;

          if (isGoal) {
            hiddenInput = document.getElementById('calc-goal');
          } else {
            hiddenInput = group.parentElement.querySelector('input[type="hidden"]');
            if (!hiddenInput) {
              hiddenInput = group.nextElementSibling;
            }
          }
          if (hiddenInput && hiddenInput.type === 'hidden') {
            hiddenInput.value = value;
          }

          // Formula toggle: show/hide LBM fields
          if (group.id === 'calcFormulaSelect') {
            var lbmFields = document.getElementById('tbCalcLbmFields');
            if (lbmFields) {
              lbmFields.style.display = value === 'lean_body_mass' ? 'block' : 'none';
            }
          }
        });
      });
    });

    /* ----------------------------------------------------------
       3. STEP NAVIGATION
    ---------------------------------------------------------- */
    function showStep(step) {
      document.querySelectorAll('.tb-calc__step').forEach(function (el) {
        el.classList.remove('tb-calc__step--active');
      });
      var target = document.querySelector('.tb-calc__step[data-step="' + step + '"]');
      if (target) {
        target.classList.add('tb-calc__step--active');
        // Re-trigger animation
        target.style.animation = 'none';
        target.offsetHeight; // force reflow
        target.style.animation = '';
      }

      // Update progress
      if (step <= TOTAL_STEPS) {
        var pct = (step / TOTAL_STEPS) * 100;
        if (progressBar) progressBar.style.width = pct + '%';
        if (stepIndicator) {
          stepIndicator.textContent = 'Step ' + step + ' of ' + TOTAL_STEPS;
          stepIndicator.style.display = '';
        }
      } else {
        // Results step - full progress
        if (progressBar) progressBar.style.width = '100%';
        if (stepIndicator) stepIndicator.style.display = 'none';
      }

      currentStep = step;

      // Scroll to top of calculator
      var calcSection = document.getElementById('macro-calculator');
      if (calcSection) {
        calcSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    /* ----------------------------------------------------------
       4. VALIDATION
    ---------------------------------------------------------- */
    function validateStep(step) {
      switch (step) {
        case 1:
          var firstName = document.getElementById('calc-first-name');
          var email = document.getElementById('calc-email');
          var valid = true;
          if (!firstName || !firstName.value.trim()) {
            firstName.classList.add('tb-input--error');
            valid = false;
          } else {
            firstName.classList.remove('tb-input--error');
          }
          if (!email || !email.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
            email.classList.add('tb-input--error');
            valid = false;
          } else {
            email.classList.remove('tb-input--error');
          }
          return valid;

        case 2:
          var age = document.getElementById('calc-age');
          var height = document.getElementById('calc-height');
          var weight = document.getElementById('calc-weight');
          var v = true;
          [age, height, weight].forEach(function (el) {
            if (!el || !el.value || el.validity.badInput || el.validity.rangeUnderflow || el.validity.rangeOverflow) {
              el.classList.add('tb-input--error');
              v = false;
            } else {
              el.classList.remove('tb-input--error');
            }
          });
          return v;

        case 3:
          var formula = document.getElementById('calc-formula').value;
          if (formula === 'lean_body_mass') {
            var bf = document.getElementById('calc-bodyfat');
            if (!bf || !bf.value || bf.validity.badInput || bf.validity.rangeUnderflow || bf.validity.rangeOverflow) {
              bf.classList.add('tb-input--error');
              return false;
            } else {
              bf.classList.remove('tb-input--error');
            }
          }
          return true;

        case 4:
          var activity = document.getElementById('calc-activity').value;
          if (!activity) {
            // Highlight the card select area
            return false;
          }
          return true;

        case 5:
          var goal = document.getElementById('calc-goal').value;
          if (!goal) return false;
          return true;

        case 6:
          return true; // All have defaults

        default:
          return true;
      }
    }

    /* ----------------------------------------------------------
       5. NEXT / BACK BUTTONS
    ---------------------------------------------------------- */
    document.querySelectorAll('.tb-calc__next').forEach(function (btn) {
      btn.addEventListener('click', async function () {
        var step = parseInt(btn.getAttribute('data-step'));
        if (!validateStep(step)) return;

        // Step 1: do not continue until Klaviyo has accepted the lead.
        if (step === 1) {
          setIntegrationMessage(captureMessage, '');
          setButtonPending(btn, true, 'Saving...');

          try {
            await captureEmail();
          } catch (error) {
            setIntegrationMessage(captureMessage, 'We could not save your email. Please check your connection and try again.');
            return;
          } finally {
            setButtonPending(btn, false);
          }
        }

        // Step 6: calculate, persist the final profile data and create the
        // completion event before showing results. This keeps result-email
        // flows from firing with incomplete or stale properties.
        if (step === TOTAL_STEPS) {
          var results = calculateMacros();
          setIntegrationMessage(completionMessage, '');
          setButtonPending(btn, true, 'Preparing results...');

          try {
            await syncKlaviyoCompletion(results);
          } catch (error) {
            setIntegrationMessage(completionMessage, 'We could not send your results to your email. Please check your connection and try again.');
            return;
          } finally {
            setButtonPending(btn, false);
          }

          showStep(7);
          return;
        }

        showStep(step + 1);
      });
    });

    document.querySelectorAll('.tb-calc__back').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-step'));
        if (step > 1) showStep(step - 1);
      });
    });

    // Recalculate button
    var recalcBtn = document.getElementById('tbCalcRecalculate');
    if (recalcBtn) {
      recalcBtn.addEventListener('click', function () {
        showStep(2); // Go back to basic info
      });
    }



    /* ----------------------------------------------------------
       6. KLAVIYO EMAIL CAPTURE
    ---------------------------------------------------------- */
    var capturedEmail = '';
    var capturedFirstName = '';

    // Traffic source detection
    // UTM params take priority; if absent, referrer is checked for known search engines
    // so organic search traffic is reliably identifiable in Klaviyo.
    var _params = new URLSearchParams(window.location.search);
    var _referrer = document.referrer || '';
    var _isOrganicSearch = /google\.|bing\.|yahoo\.|duckduckgo\.|baidu\.|yandex\./.test(_referrer);
    var _trafficSource = _params.get('utm_source') ||
      (_isOrganicSearch ? 'organic-search' : (_referrer ? _referrer : 'direct'));
    var _trafficMedium = _params.get('utm_medium') ||
      (_isOrganicSearch ? 'organic' : 'web');
    var _utmSource = _params.get('utm_source') || '';
    var _utmMedium = _params.get('utm_medium') || '';
    var _utmCampaign = _params.get('utm_campaign') || '';
    var _utmContent = _params.get('utm_content') || '';
    var _utmTerm = _params.get('utm_term') || '';
    var _landingPage = window.location.href;

    // Device type for send-time optimisation
    var _deviceType = window.innerWidth <= 768 ? 'mobile' : (window.innerWidth <= 1024 ? 'tablet' : 'desktop');

    // Klaviyo IDs injected from theme settings via data attributes on the wizard element
    var KLAVIYO_KEY = wizard.getAttribute('data-klaviyo-key') || '';
    var KLAVIYO_REVISION = '2026-07-15';
    var KLAVIYO_REQUEST_TIMEOUT = 12000;
    var _calculatorSessionId = (window.crypto && typeof window.crypto.randomUUID === 'function')
      ? window.crypto.randomUUID()
      : String(Date.now()) + '-' + Math.random().toString(36).slice(2);
    // Users are subscribed to both lists simultaneously on Step 1 completion
    var KLAVIYO_MACRO_LISTS = [
      wizard.getAttribute('data-klaviyo-list') || '',
      wizard.getAttribute('data-klaviyo-list-2') || ''
    ].filter(function(id) { return id !== ''; });

    function getAttributionProperties() {
      return {
        'Macro Calculator Source': 'Macro Calculator',
        'Traffic Source': _trafficSource,
        'Traffic Medium': _trafficMedium,
        'UTM Source': _utmSource,
        'UTM Medium': _utmMedium,
        'UTM Campaign': _utmCampaign,
        'UTM Content': _utmContent,
        'UTM Term': _utmTerm,
        'Referrer': _referrer,
        'Landing Page': _landingPage,
        'Device Type': _deviceType,
        '$source': _trafficSource,
        '$medium': _trafficMedium,
        '$campaign': _utmCampaign,
        '$content': _utmContent,
        '$term': _utmTerm,
        '$referrer': _referrer,
        '$first_page': _landingPage
      };
    }

    async function klaviyoRequest(path, payload, requestName) {
      if (!KLAVIYO_KEY) {
        console.error('[Macro Calculator] Klaviyo public API key is missing.');
        throw new Error('Klaviyo configuration is missing.');
      }

      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timeoutId = controller ? window.setTimeout(function () {
        controller.abort();
      }, KLAVIYO_REQUEST_TIMEOUT) : null;

      try {
        var response = await fetch('https://a.klaviyo.com' + path + '?company_id=' + encodeURIComponent(KLAVIYO_KEY), {
          method: 'POST',
          headers: {
            'content-type': 'application/vnd.api+json',
            'accept': 'application/vnd.api+json',
            'revision': KLAVIYO_REVISION
          },
          body: JSON.stringify(payload),
          signal: controller ? controller.signal : undefined
        });

        if (response.status !== 202) {
          var responseDetail = '';
          try {
            var errorPayload = await response.json();
            if (errorPayload && Array.isArray(errorPayload.errors)) {
              responseDetail = errorPayload.errors.map(function (item) {
                return item.detail || item.title || item.code || 'Unknown Klaviyo error';
              }).join('; ');
            }
          } catch (parseError) {
            responseDetail = '';
          }

          console.error('[Macro Calculator] ' + requestName + ' failed.', {
            status: response.status,
            detail: responseDetail
          });
          throw new Error(requestName + ' failed with HTTP ' + response.status + '.');
        }

        return response.status;
      } catch (error) {
        if (error && error.name === 'AbortError') {
          console.error('[Macro Calculator] ' + requestName + ' timed out.');
        } else if (!error || !/^.+ failed with HTTP \d+\.$/.test(error.message || '')) {
          console.error('[Macro Calculator] ' + requestName + ' could not be completed.', {
            message: error && error.message ? error.message : 'Network error'
          });
        }
        throw error;
      } finally {
        if (timeoutId) window.clearTimeout(timeoutId);
      }
    }

    function subscribeToKlaviyoList(listId, email, firstName, profileProperties) {
      return klaviyoRequest('/client/subscriptions', {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Macro Calculator',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: firstName,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED'
                      }
                    }
                  },
                  properties: profileProperties
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId
              }
            }
          }
        }
      }, 'Subscription request');
    }

    function updateKlaviyoProfile(profileProperties) {
      return klaviyoRequest('/client/profiles', {
        data: {
          type: 'profile',
          attributes: {
            email: capturedEmail,
            first_name: capturedFirstName,
            properties: profileProperties
          }
        }
      }, 'Profile update');
    }

    function sendKlaviyoEvent(eventName, eventProperties, profileProperties, uniqueSuffix) {
      return klaviyoRequest('/client/events', {
        data: {
          type: 'event',
          attributes: {
            properties: eventProperties,
            time: new Date().toISOString(),
            unique_id: _calculatorSessionId + '-' + uniqueSuffix,
            metric: {
              data: {
                type: 'metric',
                attributes: {
                  name: eventName
                }
              }
            },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: capturedEmail,
                  first_name: capturedFirstName,
                  properties: profileProperties
                }
              }
            }
          }
        }
      }, eventName + ' event');
    }

    async function captureEmail() {
      var firstName = document.getElementById('calc-first-name');
      var email = document.getElementById('calc-email');
      if (!firstName || !email) throw new Error('Lead capture fields are missing.');

      capturedFirstName = firstName.value.trim();
      capturedEmail = email.value.trim();

      if (!KLAVIYO_KEY || KLAVIYO_MACRO_LISTS.length === 0) {
        console.error('[Macro Calculator] Klaviyo public API key or macro calculator list is missing.');
        throw new Error('Klaviyo configuration is missing.');
      }

      // Do not write Calculator Goal at Step 1. The user has not selected it
      // yet, and a blank value would overwrite an existing profile property.
      // Do not reset Macro Calculator Completed to false either: returning
      // users may already have a valid historical completion.
      var startedAt = new Date().toISOString();
      var profileProperties = Object.assign({
        'Macro Calculator Lead': true,
        'Macro Calculator Started At': startedAt,
        'Accepts Marketing': true
      }, getAttributionProperties());

      await Promise.all(KLAVIYO_MACRO_LISTS.map(function (listId) {
        return subscribeToKlaviyoList(listId, capturedEmail, capturedFirstName, profileProperties);
      }));

      await sendKlaviyoEvent('Started Macro Calculator', {
        first_name: capturedFirstName,
        email: capturedEmail,
        started_at: startedAt,
        traffic_source: _trafficSource,
        traffic_medium: _trafficMedium,
        device_type: _deviceType,
        utm_source: _utmSource,
        utm_medium: _utmMedium,
        utm_campaign: _utmCampaign,
        utm_content: _utmContent,
        utm_term: _utmTerm,
        referrer: _referrer,
        landing_page: _landingPage
      }, profileProperties, 'started');
    }

    async function syncKlaviyoCompletion(results) {
      if (!capturedEmail) throw new Error('Captured email is missing.');

      var profileProperties = Object.assign({
        'Macro Calculator Lead': true,
        'Macro Calculator Completed': true,
        'Macro Calculator Completed At': results.completed_at,
        'Accepts Marketing': true,
        'Gender': results.gender,
        'Calculator Goal': results.goal,
        'Macro Calculator Calories': results.calories,
        'Macro Calculator Protein Grams': results.protein_grams,
        'Macro Calculator Carbohydrate Grams': results.carbs_grams,
        'Macro Calculator Fat Grams': results.fat_grams,
        'Macro Calculator Activity Level': results.activity_level,
        'Macro Calculator Formula': results.calculation_formula,
        'Macro Calculator Preference': results.macro_preference,
        'Macro Calculator Breastfeeding': results.breastfeeding,
        'Macro Calculator Previously Restricted': results.calorie_restricted
      }, getAttributionProperties());

      var eventProperties = {
        email: capturedEmail,
        first_name: capturedFirstName,
        gender: results.gender,
        calories: results.calories,
        protein_grams: results.protein_grams,
        carbs_grams: results.carbs_grams,
        fat_grams: results.fat_grams,
        protein_pct: results.protein_pct,
        carbs_pct: results.carbs_pct,
        fat_pct: results.fat_pct,
        goal: results.goal,
        activity_level: results.activity_level,
        calculation_formula: results.calculation_formula,
        macro_preference: results.macro_preference,
        breastfeeding: results.breastfeeding,
        calorie_restricted: results.calorie_restricted,
        traffic_source: _trafficSource,
        traffic_medium: _trafficMedium,
        device_type: _deviceType,
        utm_source: _utmSource,
        utm_medium: _utmMedium,
        utm_campaign: _utmCampaign,
        utm_content: _utmContent,
        utm_term: _utmTerm,
        referrer: _referrer,
        landing_page: _landingPage
      };

      // Persist final properties first. They are also included on the event's
      // profile so metric-triggered flows receive the same final state.
      await updateKlaviyoProfile(profileProperties);
      await sendKlaviyoEvent('Macro Calculator Completed', eventProperties, profileProperties, 'completed');
    }



    /* ----------------------------------------------------------
       7. CALCULATION ENGINE
       Exact replica of the existing THE BOD calculator logic
    ---------------------------------------------------------- */
    function calculateMacros() {
      var bmr = 0;
      var tdee = 0;
      var calories = 0;
      var lbm = 0;

      var carbohydrate_gram = 0;
      var protein_gram = 0;
      var fat_gram = 0;

      var carbohydrate_calories = 0;
      var protein_calories = 0;
      var fat_calories = 0;

      // Gather values
      var gender = document.getElementById('calc-gender').value;
      var age = parseFloat(document.getElementById('calc-age').value);
      var height = parseFloat(document.getElementById('calc-height').value);
      var weight = parseFloat(document.getElementById('calc-weight').value);
      var body_fat = parseFloat(document.getElementById('calc-bodyfat').value) || 0;
      var calculation_formula = document.getElementById('calc-formula').value;
      var total_daily_energy = document.getElementById('calc-activity').value;
      var goal = document.getElementById('calc-goal').value;
      var macro_preference = document.getElementById('calc-macro-pref').value;
      var breastfeeding = document.getElementById('calc-breastfeeding').value;
      var calorie_restricted = document.getElementById('calc-calorie-restricted').value;
      var athleticism = document.getElementById('calc-athleticism').value;

      /* --- 1. BMR CALCULATION --- */
      if (calculation_formula === 'total_body_weight') {
        if (gender === 'Female') {
          bmr = (weight * 10) + (height * 6.25) - (age * 5) - 161;
        } else {
          bmr = (weight * 10) + (height * 6.25) - (age * 5) + 5;
        }
      } else {
        // Lean body mass
        lbm = weight * ((100 - body_fat) / 100);
        if (athleticism === 'non_advanced') {
          bmr = 21.6 * lbm + 370;
        } else {
          bmr = 22 * lbm + 500;
        }
      }

      /* --- 2. TOTAL DAILY ENERGY EXPENDITURE --- */
      switch (total_daily_energy) {
        case 'sedentary':       tdee = 1.2;    break;
        case 'light_activity':  tdee = 1.375;  break;
        case 'moderately_active': tdee = 1.55; break;
        case 'active':          tdee = 1.725;  break;
        case 'very_active':     tdee = 1.9;    break;
      }
      calories = bmr * tdee;

      /* --- 3. GOAL --- */
      switch (goal) {
        case 'conservative_cut': calories *= 0.9;  break;
        case 'recommended_cut':  calories *= 0.85; break;
        case 'aggressive_cut':   calories *= 0.8;  break;
        case 'maintenance':      calories *= 1;    break;
        case 'lean_gain':        calories *= 1.05; break;
        case 'moderate_gain':    calories *= 1.1;  break;
        case 'aggressive_gain':  calories *= 1.15; break;
      }

      /* --- 4. BREASTFEEDING --- */
      if (breastfeeding === 'yes') {
        calories += 450;
      }

      /* --- 6. PROTEIN --- */
      if (calculation_formula === 'total_body_weight') {
        switch (total_daily_energy) {
          case 'sedentary':        protein_gram = weight * 1.5;  break;
          case 'light_activity':   protein_gram = weight * 1.75; break;
          case 'moderately_active': protein_gram = weight * 2;   break;
          case 'active':           protein_gram = weight * 2.25; break;
          case 'very_active':      protein_gram = weight * 2.5;  break;
        }
        // Cap protein
        if (gender === 'Female') {
          protein_gram = protein_gram > 200 ? 200 : protein_gram;
        } else {
          protein_gram = protein_gram > 300 ? 300 : protein_gram;
        }
      } else {
        switch (total_daily_energy) {
          case 'sedentary':        protein_gram = lbm * 2;    break;
          case 'light_activity':   protein_gram = lbm * 2.25; break;
          case 'moderately_active': protein_gram = lbm * 2.5; break;
          case 'active':           protein_gram = lbm * 2.75; break;
          case 'very_active':      protein_gram = lbm * 3;    break;
        }
      }

      var total_calories = calories = Math.round(calories);
      protein_gram = Math.round(protein_gram);
      protein_calories = protein_gram * 4;

      /* --- 7. FAT --- */
      switch (macro_preference) {
        case 'high_carbohydrate_lower_fat':
          fat_gram = calories * 0.2 / 9;
          break;
        case 'moderate_carbohydrate_moderate_fat':
          fat_gram = calories * 0.25 / 9;
          break;
        case 'lower_carbohydrate_higher_fat':
          fat_gram = calories * 0.3 / 9;
          break;
      }
      fat_gram = Math.round(fat_gram);
      fat_calories = fat_gram * 9;

      /* --- 8. CARBOHYDRATE --- */
      carbohydrate_calories = calories - fat_calories - protein_calories;
      carbohydrate_gram = Math.round(carbohydrate_calories / 4);

      /* --- 9. DISPLAY RESULTS --- */
      var proteinPct = Math.round(protein_calories / total_calories * 100);
      var carbsPct = Math.round(carbohydrate_calories / total_calories * 100);
      var fatPct = Math.round(fat_calories / total_calories * 100);

      // Animated number reveal
      animateNumber('calcCalories', total_calories);
      animateNumber('calcProtein', protein_gram);
      animateNumber('calcCarbs', carbohydrate_gram);
      animateNumber('calcFat', fat_gram);

      document.getElementById('calcProteinPct').textContent = proteinPct + '%';
      document.getElementById('calcCarbsPct').textContent = carbsPct + '%';
      document.getElementById('calcFatPct').textContent = fatPct + '%';

      // Draw donut chart
      drawDonutChart(proteinPct, carbsPct, fatPct);

      return {
        completed_at: new Date().toISOString(),
        gender: gender,
        calories: total_calories,
        protein_grams: protein_gram,
        carbs_grams: carbohydrate_gram,
        fat_grams: fat_gram,
        protein_pct: proteinPct,
        carbs_pct: carbsPct,
        fat_pct: fatPct,
        goal: goal,
        activity_level: total_daily_energy,
        calculation_formula: calculation_formula,
        macro_preference: macro_preference,
        breastfeeding: breastfeeding,
        calorie_restricted: calorie_restricted
      };
    }

    /* ----------------------------------------------------------
       8. ANIMATED NUMBER REVEAL
    ---------------------------------------------------------- */
    function animateNumber(elementId, target) {
      var el = document.getElementById(elementId);
      if (!el) return;

      var start = 0;
      var duration = 1200;
      var startTime = null;

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        // Ease out cubic
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = Math.round(eased * target);
        el.textContent = current.toLocaleString();
        if (progress < 1) {
          requestAnimationFrame(step);
        }
      }
      requestAnimationFrame(step);
    }

    /* ----------------------------------------------------------
       9. DONUT CHART (Canvas - no dependencies)
    ---------------------------------------------------------- */
    function drawDonutChart(proteinPct, carbsPct, fatPct) {
      var canvas = document.getElementById('calcDonutChart');
      if (!canvas) return;

      var ctx = canvas.getContext('2d');
      var dpr = window.devicePixelRatio || 1;
      var size = 220;

      canvas.width = size * dpr;
      canvas.height = size * dpr;
      canvas.style.width = size + 'px';
      canvas.style.height = size + 'px';
      ctx.scale(dpr, dpr);

      var cx = size / 2;
      var cy = size / 2;
      var radius = 85;
      var lineWidth = 28;

      var data = [
        { pct: proteinPct, color: '#4A3832' },  // Protein - dark brown
        { pct: carbsPct,   color: '#8A7E76' },  // Carbs - driftwood
        { pct: fatPct,     color: '#D6D1CB' }   // Fat - warm grey
      ];

      var total = data.reduce(function (sum, d) { return sum + d.pct; }, 0);
      var startAngle = -Math.PI / 2; // Start from top
      var gap = 0.04; // Small gap between segments

      ctx.clearRect(0, 0, size, size);

      // Animate the chart
      var animDuration = 1000;
      var animStart = null;

      function drawFrame(timestamp) {
        if (!animStart) animStart = timestamp;
        var progress = Math.min((timestamp - animStart) / animDuration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);

        ctx.clearRect(0, 0, size, size);

        var currentAngle = startAngle;
        data.forEach(function (segment) {
          var sweep = (segment.pct / total) * (2 * Math.PI - gap * data.length) * eased;
          ctx.beginPath();
          ctx.arc(cx, cy, radius, currentAngle, currentAngle + sweep);
          ctx.strokeStyle = segment.color;
          ctx.lineWidth = lineWidth;
          ctx.lineCap = 'round';
          ctx.stroke();
          currentAngle += sweep + gap;
        });

        if (progress < 1) {
          requestAnimationFrame(drawFrame);
        }
      }
      requestAnimationFrame(drawFrame);
    }

    /* ----------------------------------------------------------
       10. INPUT FOCUS CLEAR ERROR
    ---------------------------------------------------------- */
    document.querySelectorAll('.tb-input').forEach(function (input) {
      input.addEventListener('focus', function () {
        input.classList.remove('tb-input--error');
      });
    });

    /* ----------------------------------------------------------
       11. KEYBOARD ACCESSIBILITY
    ---------------------------------------------------------- */
    document.querySelectorAll('.tb-card-select__option').forEach(function (btn) {
      btn.setAttribute('role', 'radio');
      btn.setAttribute('tabindex', '0');
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          btn.click();
        }
      });
    });

  }); // DOMContentLoaded
})();
